import { Card, CardBody, Skeleton } from '@heroui/react';
import { Container } from '@school-manage/ui/Container/Container';
import { NavigationBar } from '@school-manage/ui/NavigationBar/NavigationBar';

import { UndrawTask } from '../UndrawTask';
import { TaskSubmitRecordCardSkeleton } from './TaskSubmitRecordCardSkeleton';

export function TaskDetailSkeleton() {
  return (
    <>
      <Container hasHeaderGap={false}>
        <div>
          <UndrawTask className="text-primary mx-auto max-w-2xl" />
          <div className="bg-content2 mt-[-16px] flex flex-col gap-4 rounded-lg p-4">
            <div className="mt-[16px] flex flex-col gap-y-2">
              <Skeleton className="!bg-content1 mx-auto h-6 w-2/3 rounded-lg" />
              <Skeleton className="!bg-content1 h-4 w-full rounded-lg" />
              <Skeleton className="!bg-content1 h-4 w-full rounded-lg" />
            </div>
            <div className="flex gap-4">
              <Card className="w-full" shadow="sm">
                <CardBody className="items-center gap-2">
                  <Skeleton className="size-8 rounded-lg" />
                  <Skeleton className="h-4 w-2/3 rounded-lg" />
                </CardBody>
              </Card>
              <Card className="w-full" shadow="sm">
                <CardBody className="items-center gap-2">
                  <Skeleton className="size-8 rounded-lg" />
                  <Skeleton className="h-4 w-2/3 rounded-lg" />
                </CardBody>
              </Card>
            </div>

            {Array.from(Array(2).keys()).map((i) => (
              <Card className="w-full" key={i} shadow="sm">
                <CardBody className="gap-2">
                  <Skeleton className="h-6 w-2/3 rounded-lg" />
                  <Skeleton className="h-4 w-1/3 rounded-lg" />
                </CardBody>
              </Card>
            ))}

            <Skeleton className="!bg-content1 mx-auto h-5 w-2/3 rounded-lg" />
            <Skeleton className="!bg-content1 h-9 w-full rounded-lg" />
            <Skeleton className="!bg-content1 h-5 w-2/3 rounded-lg" />
          </div>
        </div>

        <div className="bg-content2 flex flex-col gap-4 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <Skeleton className="!bg-content1 h-6 w-1/4 rounded-lg" />
          </div>

          <div className="flex flex-col gap-2">
            <TaskSubmitRecordCardSkeleton count={2} />
          </div>
        </div>
      </Container>
      <NavigationBar />
    </>
  );
}
